export default "__VITE_ASSET__BU4MGzIb__"